import { defineComponent, reactive } from "vue";
export default defineComponent({
  name: "artistSyno",
  props: {
    artistDesc: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var data = reactive({});
    return {};
  },
  components: {}
});